import { defineComponent, openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  class: "coop-img-asset__container"
};
const _hoisted_2 = ["srcset"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["srcset"];
const _hoisted_5 = ["src"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CoopImgAsset",
  props: {
    isStatic: {
      type: Boolean
    }
  },
  setup(__props) {
    const images = {
      gif: {
        upper: "https://www.rei.com/dam/21716893_cb_brandequity_ripstoptesting.gif",
        lower: "https://www.rei.com/dam/21716894_cb_brandequity_fieldtesting_halfdome.gif"
      },
      static: {
        upper: "https://www.rei.com/dam/21697030_cb-equity-video-sodo-stillframe.png",
        lower: "https://www.rei.com/dam/21512221_chorski_20250116_0085_film_web_xs.jpeg"
      }
    };
    const getSrc = (gifSrc, staticSrc) => {
      if (__props.isStatic) return staticSrc;
      return gifSrc;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", _hoisted_1, [createElementVNode("picture", null, [createElementVNode("source", {
        srcset: images.static.upper,
        media: "(prefers-reduced-motion: reduce)"
      }, null, 8, _hoisted_2), createElementVNode("img", {
        class: "coop-img-asset__img",
        src: getSrc(images.gif.upper, images.static.upper),
        alt: "Rei Coop brand gif"
      }, null, 8, _hoisted_3)]), createElementVNode("picture", null, [createElementVNode("source", {
        srcset: images.static.lower,
        media: "(prefers-reduced-motion: reduce)"
      }, null, 8, _hoisted_4), createElementVNode("img", {
        class: "coop-img-asset__img coop-img-asset__img--secondary",
        src: getSrc(images.gif.lower, images.static.lower),
        alt: "REI Coop brand tent with a user inside wearing a REI Coop brand sweater"
      }, null, 8, _hoisted_5)])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=CoopImgAsset2.mjs.map
